import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { EJobType } from './job-type.enum';
import { EJobState } from './job-state.enum';
import { ISortOptions, IPaginationOptions } from '../core/ISortOptions';
import { HttpUtilsService } from 'app/shared/services/http.utils.service';
import { IJob, IJobLogsResult, IJobResult } from './IJob';


@Injectable()
export class JobsService {
  private _endPoints = {
    jobs: 'api/Scheduler/Jobs',
    jobLogs: 'api/Scheduler/Jobs/Logs',
    userJobLogs: 'api/Scheduler/UserJob/Logs'
  };

  constructor(
    private _restApi: RestApi,
    private _httpUtilsService: HttpUtilsService
  ) {}

  getJobsByType(
    type: EJobType,
    jobState: EJobState = EJobState.Waiting,
    sortOptions?: ISortOptions,
    paginationOptions?: IPaginationOptions
  ): Promise<IJobResult> {
    const url = `${
      this._endPoints.jobs
    }/${type.toString()}/${jobState.toString()}`;
    const queryParams = {};
    if (sortOptions && sortOptions.columnName) {
      queryParams['orderColumn'] = sortOptions.columnName;
      queryParams['orderType'] = sortOptions.orderType;
    }
    if (paginationOptions) {
      queryParams['currentPage'] = paginationOptions.currentPage;
      queryParams['limit'] = paginationOptions.pageSize;
    }

    const query = this._httpUtilsService.buildQuery(queryParams);

    return this._restApi.get(`${url}?${query}`).toPromise();
  }

  getJobById(jobId: number): Promise<any> {
    const url = `${this._endPoints.jobs}/${jobId}`;
    return this._restApi.get(`${url}`).toPromise();
  }

  getJobLogsById(
    jobId: number,
    queryParams: { [key: string]: string } = {}
  ): Promise<IJobLogsResult> {
    const url = `${
      this._endPoints.jobLogs
    }/${jobId}?${this._httpUtilsService.buildQuery(queryParams)}`;
    return this._restApi.get(`${url}`).toPromise();
  }

  getUserJobLogsByGuid(
    jobGuid: string,
    queryParams: { [key: string]: string } = {}
  ): Promise<IJobLogsResult> {
    const url = `${
      this._endPoints.userJobLogs
    }/${jobGuid}?${this._httpUtilsService.buildQuery(queryParams)}`;
    return this._restApi.get(`${url}`).toPromise();
  }

  updateJob(id: number, job: IJob) {
    const url = `${this._endPoints.jobs}`;
    return this._restApi.post(`${url}`, job).toPromise();
  }
}
